import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDownIcon } from 'lucide-react';
import { useTranslation } from '../i18n';
export function PricingPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const {
    t
  } = useTranslation();
  const faqKeys = [{
    q: 'pricing.faq0Q',
    a: 'pricing.faq0A'
  }, {
    q: 'pricing.faq1Q',
    a: 'pricing.faq1A'
  }, {
    q: 'pricing.faq2Q',
    a: 'pricing.faq2A'
  }, {
    q: 'pricing.faq3Q',
    a: 'pricing.faq3A'
  }];
  return <div className="pt-24" data-id="element-423">
      <section className="relative py-24 overflow-hidden" data-id="element-424">
        <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-425">
          <h1 className="text-5xl lg:text-7xl font-bold leading-[1.1] mb-6" data-id="element-426">
            {t('pricing.heroTitle')}
            <span className="text-gradient" data-id="element-427">
              {t('pricing.heroTitleHighlight')}
            </span>
          </h1>
          <p className="text-xl text-white/60 leading-relaxed max-w-3xl mx-auto" data-id="element-428">
            {t('pricing.heroDesc')}
          </p>
        </div>
      </section>

      <section className="py-16 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-429">
        <div className="max-w-5xl mx-auto px-6" data-id="element-430">
          <div className="mb-10 text-center" data-id="element-431">
            <h2 className="text-3xl font-bold mb-2 text-gradient" data-id="element-432">
              {t('pricing.mapTitle')}
            </h2>
            <p className="text-white/60" data-id="element-433">{t('pricing.mapSubtitle')}</p>
          </div>
          <div className="bg-[#050505] rounded-3xl border border-white/10 overflow-hidden" data-id="element-434">
            <div className="grid grid-cols-3 border-b border-white/10 bg-white/5" data-id="element-435">
              <div className="p-6 font-semibold text-white/80" data-id="element-436">
                {t('pricing.tier')}
              </div>
              <div className="p-6 font-semibold text-white/80" data-id="element-437">
                {t('pricing.annualLicense')}
              </div>
              <div className="p-6 font-semibold text-white/80" data-id="element-438">
                {t('pricing.setup')}
              </div>
            </div>
            <div className="grid grid-cols-3 border-b border-white/10 hover:bg-white/5 transition-colors" data-id="element-439">
              <div className="p-6 text-white" data-id="element-440">{t('pricing.city')}</div>
              <div className="p-6 text-white" data-id="element-441">€4,500</div>
              <div className="p-6 text-white" data-id="element-442">€2,000</div>
            </div>
            <div className="grid grid-cols-3 border-b border-white/10 hover:bg-white/5 transition-colors" data-id="element-443">
              <div className="p-6 text-white" data-id="element-444">{t('pricing.region')}</div>
              <div className="p-6 text-white" data-id="element-445">€9,000</div>
              <div className="p-6 text-white" data-id="element-446">€3,000</div>
            </div>
            <div className="grid grid-cols-3 border-b border-white/10 hover:bg-white/5 transition-colors" data-id="element-447">
              <div className="p-6 text-white" data-id="element-448">{t('pricing.country')}</div>
              <div className="p-6 text-white" data-id="element-449">€18,000</div>
              <div className="p-6 text-white" data-id="element-450">€4,500</div>
            </div>
            <div className="grid grid-cols-3 hover:bg-white/5 transition-colors" data-id="element-451">
              <div className="p-6 text-white" data-id="element-452">{t('pricing.hotelProperty')}</div>
              <div className="p-6 text-white" data-id="element-453">€2,400</div>
              <div className="p-6 text-white" data-id="element-454">€1,500</div>
            </div>
          </div>
          <p className="text-sm text-white/40 mt-6 text-center italic" data-id="element-455">
            {t('pricing.mapIncludes')}
          </p>
        </div>
      </section>

      <section className="py-16 bg-[#050505] relative z-20 border-t border-white/5" data-id="element-456">
        <div className="max-w-5xl mx-auto px-6" data-id="element-457">
          <div className="mb-10 text-center" data-id="element-458">
            <h2 className="text-3xl font-bold mb-2 text-gradient" data-id="element-459">
              {t('pricing.sparkTitle')}
            </h2>
            <p className="text-white/60" data-id="element-460">{t('pricing.sparkSubtitle')}</p>
          </div>
          <div className="bg-[#0A0A0A] rounded-3xl border border-white/10 overflow-hidden" data-id="element-461">
            <div className="grid grid-cols-3 border-b border-white/10 bg-white/5" data-id="element-462">
              <div className="p-6 font-semibold text-white/80" data-id="element-463">
                {t('pricing.tier')}
              </div>
              <div className="p-6 font-semibold text-white/80" data-id="element-464">
                {t('pricing.annualLicense')}
              </div>
              <div className="p-6 font-semibold text-white/80" data-id="element-465">
                {t('pricing.setup')}
              </div>
            </div>
            <div className="grid grid-cols-3 border-b border-white/10 hover:bg-white/5 transition-colors" data-id="element-466">
              <div className="p-6 text-white" data-id="element-467">{t('pricing.hotelProperty')}</div>
              <div className="p-6 text-white" data-id="element-468">€2,400</div>
              <div className="p-6 text-white" data-id="element-469">€1,200</div>
            </div>
            <div className="grid grid-cols-3 border-b border-white/10 hover:bg-white/5 transition-colors" data-id="element-470">
              <div className="p-6 text-white" data-id="element-471">
                {t('pricing.dmoTourismBoard')}
              </div>
              <div className="p-6 text-white" data-id="element-472">€5,400</div>
              <div className="p-6 text-white" data-id="element-473">€2,000</div>
            </div>
            <div className="grid grid-cols-3 hover:bg-white/5 transition-colors" data-id="element-474">
              <div className="p-6 text-white" data-id="element-475">{t('pricing.agency')}</div>
              <div className="p-6 text-white" data-id="element-476">€3,600</div>
              <div className="p-6 text-white" data-id="element-477">€1,500</div>
            </div>
          </div>
          <p className="text-sm text-white/40 mt-6 text-center italic" data-id="element-478">
            {t('pricing.sparkIncludes')}
          </p>
        </div>
      </section>

      <section className="py-16 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-479">
        <div className="max-w-5xl mx-auto px-6" data-id="element-480">
          <div className="mb-10 text-center" data-id="element-481">
            <h2 className="text-3xl font-bold mb-2 text-gradient" data-id="element-482">
              {t('pricing.opsTitle')}
            </h2>
            <p className="text-white/60" data-id="element-483">{t('pricing.opsSubtitle')}</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-484">
            <div className="bg-[#050505] border border-white/10 rounded-2xl p-8 border-gradient-animated" data-id="element-485">
              <div className="relative z-10" data-id="element-486">
                <h3 className="text-xl font-medium text-white mb-2" data-id="element-487">
                  {t('pricing.annualLicense')}
                </h3>
                <div className="flex items-baseline gap-2 mb-4" data-id="element-488">
                  <p className="text-3xl font-bold text-gradient" data-id="element-489">€4,800</p>
                  <span className="text-lg text-white/40 font-normal" data-id="element-490">
                    {t('pricing.year')}
                  </span>
                  <span className="text-white/40 mx-2" data-id="element-491">+</span>
                  <p className="text-3xl font-bold text-gradient" data-id="element-492">€500</p>
                  <span className="text-lg text-white/40 font-normal" data-id="element-493">
                    {t('pricing.op')}
                  </span>
                </div>
                <p className="text-sm text-white/60 leading-relaxed mb-6" data-id="element-494">
                  {t('pricing.platformLicenseDesc')}
                </p>
                <div className="pt-6 border-t border-white/10" data-id="element-495">
                  <p className="text-sm text-white/60 leading-relaxed" data-id="element-496">
                    {t('pricing.perOperationDesc')}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-[#050505] border border-white/10 rounded-2xl p-8 flex flex-col" data-id="element-497">
              <div className="mb-auto" data-id="element-498">
                <div className="flex justify-between items-start mb-2" data-id="element-499">
                  <h3 className="text-xl font-medium text-white" data-id="element-500">
                    {t('pricing.singleOperation')}
                  </h3>
                  <span className="px-3 py-1 bg-white/5 border border-white/10 rounded-full text-xs text-white/60" data-id="element-501">
                    {t('pricing.noCommitment')}
                  </span>
                </div>
                <p className="text-3xl font-bold text-white mb-4" data-id="element-502">
                  €3,000{' '}
                  <span className="text-lg text-white/40 font-normal" data-id="element-503">
                    {t('pricing.oneTimeLabel')}
                  </span>
                </p>
                <p className="text-sm text-white/60 leading-relaxed" data-id="element-504">
                  {t('pricing.singleOperationDesc')}
                </p>
              </div>
            </div>
          </div>
          <p className="text-sm text-white/40 text-center italic" data-id="element-505">
            {t('pricing.exampleNote')}
          </p>
        </div>
      </section>

      <section className="py-12 bg-[#050505] relative z-20" data-id="element-506">
        <div className="max-w-3xl mx-auto px-6" data-id="element-507">
          <div className="p-6 rounded-2xl border border-white/10 bg-white/5 text-center" data-id="element-508">
            <p className="text-lg text-white/80" data-id="element-509">
              {t('pricing.bundleNote')}
              <span className="text-gradient font-semibold" data-id="element-510">
                {t('pricing.bundleHighlight')}
              </span>
            </p>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#0A0A0A] relative z-20 border-t border-white/5" data-id="element-511">
        <div className="max-w-3xl mx-auto px-6" data-id="element-512">
          <h2 className="text-3xl font-bold mb-12 text-center" data-id="element-513">
            {t('pricing.faqTitle')}
          </h2>
          <div className="space-y-4" data-id="element-514">
            {faqKeys.map((faq, idx) => <div key={idx} className="border border-white/10 rounded-2xl bg-[#050505] overflow-hidden" data-id="element-515">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenFaq(openFaq === idx ? null : idx)} data-id="element-516">
                  <span className={`font-medium ${openFaq === idx ? 'text-gradient' : 'text-white'}`} data-id="element-517">
                    {t(faq.q)}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-white/40 transition-transform duration-300 ${openFaq === idx ? 'rotate-180' : ''}`} data-id="element-518" />
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ${openFaq === idx ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-519">
                  <p className="text-white/60 leading-relaxed" data-id="element-520">{t(faq.a)}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      <section className="relative py-32 overflow-hidden bg-[#050505] border-t border-white/5" data-id="element-521">
        <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-50" data-id="element-522">
          <div className="aurora-blob bg-[#CC00FF] w-[400px] h-[400px] top-[10%] left-[20%] animate-aurora-2" data-id="element-523"></div>
          <div className="aurora-blob bg-[#2563EB] w-[500px] h-[500px] bottom-[10%] right-[20%] animate-aurora-1" style={{
          animationDirection: 'reverse'
        }} data-id="element-524"></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-525">
          <h2 className="text-4xl md:text-6xl font-bold mb-12" data-id="element-526">
            {t('pricing.ctaTitle')}
            <span className="text-gradient" data-id="element-527">{t('pricing.ctaHighlight')}</span>
          </h2>
          <a href="https://calendar.app.google/kAzzsMuwfngdzNZf9" target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-animated rounded-full px-10 py-5 text-lg font-bold text-white hover:scale-105 transition-transform duration-300 shadow-[0_0_40px_rgba(0,229,255,0.3)]" data-id="element-528">
            {t('pricing.ctaCta')}
          </a>
        </div>
      </section>
    </div>;
}